module.exports = __webpack_public_path__ + "img/4.017b6e03.png";